import React from 'react'
import DateUtils from '../../inumet_js_lib/utils/dateUtils'
import MarkerPtoPronosMarino from './markerPtoPronosMarino'
import PropTypes from 'prop-types'
import { useMap } from 'react-leaflet'
import { LatLng } from 'leaflet'

//import './markerPtoPronosMarino.css'

function selectSerie(variables, nombre) {
    let itemVars = variables.find((itemVariables) => {
        return itemVariables.Nombre === nombre
    })
    if (itemVars) {
        return itemVars.data
    }
    return null
}

export default function MarkersDatosPuertos({
    dataPuertos,
    horasPronostico,
    resolucionTemporal,
}) {
    let itemsMarkers = []
    let mapRef = useMap()
    if (dataPuertos && dataPuertos.puertos) {
        dataPuertos.puertos.forEach((itemDataPuerto, index) => {
            itemsMarkers.push(
                <MarkerPtoPronosMarino
                    key={index}
                    lat={itemDataPuerto.Latitud}
                    lng={itemDataPuerto.Longitud}
                    nombrePuerto={itemDataPuerto.Nombre}
                    serieDirViento={selectSerie(
                        itemDataPuerto.Variables,
                        'windDirection'
                    )}
                    serieIntViento={selectSerie(
                        itemDataPuerto.Variables,
                        'windSpeed'
                    )}
                    serieIntRafaga={selectSerie(
                        itemDataPuerto.Variables,
                        'windRafagasGFS'
                    )}
                    seriePrecipitacion={selectSerie(
                        itemDataPuerto.Variables,
                        'precipitacionHoraGFS'
                    )}
                    serieAltOla={selectSerie(
                        itemDataPuerto.Variables,
                        'significantHeightCombinedWindWavesSwell'
                    )}
                    seriePeriodoOla={selectSerie(
                        itemDataPuerto.Variables,
                        'primaryWaveMeanPeriod'
                    )}
                    serieDirOla={selectSerie(
                        itemDataPuerto.Variables,
                        'directWaveSwellWind'
                    )}
                    serieTempAire={selectSerie(
                        itemDataPuerto.Variables,
                        'temperaturaSuperficieGFS'
                    )}
                    seriePresion={selectSerie(
                        itemDataPuerto.Variables,
                        'pressioneNivelMarGFS'
                    )}
                    serieTotalCieloCubierto={selectSerie(
                        itemDataPuerto.Variables,
                        'totalCieloCubiertoGFS'
                    )}
                    fechaInicio={DateUtils.parseDate(dataPuertos.corrida)}
                    horasPronostico={horasPronostico}
                    resolucionTemporalHoras={resolucionTemporal}
                    onMarkerClick={(e) => {
                        let latlng = new LatLng(e.latlng.lat, e.latlng.lng)
                        latlng.lat = latlng.lat + 0.8
                        mapRef.flyTo(latlng, mapRef.getZoom())
                    }}
                />
            )
        })
    }

    return itemsMarkers
}

MarkersDatosPuertos.propTypes = {
    dataPuertos: PropTypes.object,
    horasPronostico: PropTypes.number,
    resolucionTemporal: PropTypes.number,
}
